import { OrganisationState } from '../types';

export function handleRequest(state: OrganisationState): OrganisationState {
  return {
    ...state,
    loading: true,
  };
}

export function handleUploadReceiptRequest(
  state: OrganisationState
): OrganisationState {
  return {
    ...state,
    loading: true,
    uploadInitFailed: false,
  };
}

export function handleSuccess(state: OrganisationState): OrganisationState {
  return {
    ...state,
    loading: false,
  };
}

export function handleFailure(state: OrganisationState): OrganisationState {
  return {
    ...state,
    loading: false,
  };
}

export function handleUploadReceiptFailure(
  state: OrganisationState
): OrganisationState {
  return {
    ...state,
    loading: false,
    uploadInitFailed: true,
  };
}

// Reset
